<!-- router outlet -->
<router-outlet></router-outlet>
<!-- modal outlet -->
<app-modal-outlet></app-modal-outlet>
<!-- message outlet -->
<app-message-outlet></app-message-outlet>
<!--loading bar-->
<ngx-loading-bar></ngx-loading-bar>
